export default {
    // 从环境变量中获取API地址
    api: process.env.API_BASE_URL,
}


// WEBPACK FOOTER //
// ./src/serve.js